import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';

import { AppWithRouter } from './App';
import './styles/DesignerStyles.css';

import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (window.cordova) {
  window.viewType = 'phone';

  document.addEventListener(
    'deviceready',
    () => {
      window.plugins.insomnia.keepAwake();
      window.screen.orientation.lock('portrait')
      console.log('window.cordova');
      root.render(
        <div id="scroll-container">
          <React.StrictMode>
            <CookiesProvider>
              <HashRouter>
                <AppWithRouter />
              </HashRouter>
            </CookiesProvider>
          </React.StrictMode>
        </div>
        
      );
    },
    false
  );
} else {
  console.log('!window.cordova');
  root.render(
    <div id="scroll-container">
      <React.StrictMode>
        <CookiesProvider>
          <BrowserRouter>
            <AppWithRouter />
          </BrowserRouter>
        </CookiesProvider>
      </React.StrictMode>
    </div>
  );
}

reportWebVitals();
